import { CaseTeamMemberType, ReportType } from 'src/graphql';
import { USER_ROLE } from 'src/types';

// This function is used to get properties for tracking events
export const getUserCaseRole = (
  userId: number,
  caseTeam: CaseTeamMemberType[],
  caseLead?: number,
  reports?: ReportType[],
): USER_ROLE => {
  const isCaseLead = caseLead?.toString() === userId.toString();

  if (isCaseLead) return USER_ROLE.CASE_LEAD;

  const isReportAssignee = reports?.some(
    (report) =>
      (report.assignee ?? report.Assignee?.id)?.toString() ===
      userId.toString(),
  );

  if (isReportAssignee) return USER_ROLE.REPORT_ASSIGNEE;

  const userIsInCaseTeam = caseTeam?.find(
    ({ id }) => id?.toString() === userId.toString(),
  );

  if (userIsInCaseTeam) return USER_ROLE.CASE_TEAM_MEMBER;

  return USER_ROLE.SYSTEM_TEAM_MEMBER;
};
